import React from 'react';
import { Input } from 'antd';
import { useFormikContext } from 'formik';
import { FormFieldWrapper } from './FormFieldWrapper';

export const TextareaField = ({ name, label, placeholder, disabled, required }: any) => {
  const { handleChange, handleBlur, values } = useFormikContext<any>();
  return (
    <FormFieldWrapper name={name} label={label} required={required}>
      <Input.TextArea
        name={name}
        value={values[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        autoSize={{ minRows: 3, maxRows: 6 }}
      />
    </FormFieldWrapper>
  );
};
